import React from 'react';
import '../style/Footer.css'; // Ensure this path is correct

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div id="about-us" className="footer-top">
        <div className="about">
          <h3>About Us</h3>
          <p>
            AriseUpp7 is your ultimate guide to starting and running a successful business. Whether you're an aspiring entrepreneur or a seasoned business owner, we provide the knowledge and resources you need to thrive.
          </p>
        </div>
        <div className="quickInfo">
          {/* Additional content can go here */}
        </div>
        <div id="contact-us" className="contact">
          <h3>Contact Info</h3>
          <p>
            Address: Ground floor, 5/2B, Peratchi Amman Kovil street, Vannarapetti, Tirunelveli<br />
            Mobile Number: +91 94942 52543<br />
            Email: support@ariseupp7.org
          </p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2024 AriseUpp Org. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
